export default __webpack_public_path__ + "static/media/arrow-down.e4c3f948.svg";